module.exports = __webpack_public_path__ + "6307ecba4987ce5026b4f8c375c77f5d.pdf";